// removed by extract-text-webpack-plugin
module.exports = {"deviceGroupContainer":"HRgA-tKSMCXYuOmA99gBw","tableContainer":"twwmZblVXOBHKg9DjWxOT","deleteGroup":"B_4OgE6kqSERF8d78KCY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/DeviceGroup/DeviceGroup.less
// module id = 1606
// module chunks = 0